import React, { useState } from 'react';
import logo from '../assets/logo.png';
import { authApi } from '../services';
import { validateVietnamesePhone } from '../utils/phoneValidation';
import Header from '../components/Header';

function RegisterPage({ onNavigate }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [formData, setFormData] = useState({
    mobile_number: '',
    name: '',
    password: '',
    confirm_password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.mobile_number.trim() || !formData.name.trim() || !formData.password.trim() || !formData.confirm_password.trim()) {
      setError('Vui lòng nhập đầy đủ thông tin');
      return;
    }

    // Validate phone number format
    if (!validateVietnamesePhone(formData.mobile_number)) {
      setError('Số điện thoại không đúng định dạng');
      return;
    }

    // Validate name
    if (formData.name.trim().length < 2) {
      setError('Họ và tên phải có ít nhất 2 ký tự');
      return;
    }

    // Validate password strength
    if (formData.password.length < 8) {
      setError('Mật khẩu phải có ít nhất 8 ký tự');
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;
    if (!passwordRegex.test(formData.password)) {
      setError('Mật khẩu phải có ít nhất 1 chữ hoa, 1 chữ thường, 1 số và 1 ký tự đặc biệt');
      return;
    }

    if (formData.password !== formData.confirm_password) {
      setError('Mật khẩu nhập lại không khớp');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authApi.registerCustomer({
        mobile_number: formData.mobile_number,
        name: formData.name,
        password: formData.password,
        confirm_password: formData.confirm_password
      });
      
      console.log('Register response:', response);
      if(response?.ok){
        setShowSuccessPopup(true);
      }else{
        setError(response?.payload?.message || response?.message || 'Đăng ký thất bại');   
      }
      
    } catch (error) {
      console.error('Register error:', error);
      setError(error.response?.data?.message || 'Đăng ký thất bại. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  const handleSuccessConfirm = () => {
    setShowSuccessPopup(false);
    onNavigate('login');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 40 }}>
      <div style={{ background: '#fff', width: 320, minHeight: 600, borderRadius: 8, padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Header
          onCartClick={() => {
            onNavigate(-1);
          }}
          onMenuClick={() => {
            onNavigate("/");
          }}
        />
        
        <div style={{ width: '100%', marginBottom: 20, marginTop: 40 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Số điện thoại</label>
          <input 
            type="tel" 
            name="mobile_number"
            placeholder="Nhập số điện thoại" 
            style={{
              ...inputStyle,
              borderColor: error ? '#ff4444' : '#bfc3b7'
            }}
            value={formData.mobile_number}
            onChange={handleInputChange}
          />
        </div>
        
        <div style={{ width: '100%', marginBottom: 20 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Họ và tên</label>
          <input 
            type="text" 
            name="name"
            placeholder="Nhập họ và tên đầy đủ" 
            style={{
              ...inputStyle,
              borderColor: error ? '#ff4444' : '#bfc3b7'
            }}
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>
        
        <div style={{ width: '100%', marginBottom: 20 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Mật khẩu</label>
          <div style={{ position: 'relative' }}>
            <input 
              type={showPassword ? 'text' : 'password'} 
              name="password"
              placeholder="Nhập mật khẩu" 
              style={{
                ...inputStyle,
                borderColor: error ? '#ff4444' : '#bfc3b7'
              }}
              value={formData.password}
              onChange={handleInputChange}
            />
            <span onClick={() => setShowPassword(v => !v)} style={eyeIconStyle}>
              {showPassword ? '🙈' : '👁️'}
            </span>
          </div>
          <div style={{ 
            fontSize: 12, 
            color: '#666', 
            marginTop: 4,
            lineHeight: 1.4
          }}>
            Mật khẩu phải có ít nhất 8 ký tự, bao gồm: chữ hoa, chữ thường, số và ký tự đặc biệt (@$!%*?&)
          </div>
        </div>
        
        <div style={{ width: '100%', marginBottom: 32 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Nhập lại mật khẩu</label>
          <div style={{ position: 'relative' }}>
            <input 
              type={showPassword2 ? 'text' : 'password'} 
              name="confirm_password"
              placeholder="Nhập lại mật khẩu" 
              style={{
                ...inputStyle,
                borderColor: error ? '#ff4444' : '#bfc3b7'
              }}
              value={formData.confirm_password}
              onChange={handleInputChange}
            />
            <span onClick={() => setShowPassword2(v => !v)} style={eyeIconStyle}>
              {showPassword2 ? '🙈' : '👁️'}
            </span>
          </div>
        </div>

        {error && (
          <div style={{ 
            color: '#ff4444', 
            fontSize: 14, 
            marginBottom: 16,
            textAlign: 'center',
            background: '#fee',
            border: '1px solid #fcc',
            borderRadius: 8,
            padding: '8px 12px'
          }}>
            {error}
          </div>
        )}
        
		<div style={{ width: '100%', textAlign: 'right', marginBottom: 24 }}>
			<button 
        style={{
          ...btnStyle,
          opacity: loading ? 0.7 : 1,
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? 'Đang đăng ký...' : 'Đăng ký'}
      </button>
		</div>
        
        <div style={{ marginTop: 48, fontSize: 14, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          Đã có tài khoản?{' '}
          <span style={{ color: '#2a6be4', cursor: 'pointer' }} onClick={() => onNavigate('login')}>Đăng nhập</span>
        </div>
      </div>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 16,
            padding: 32,
            width: 280,
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
          }}>
            {/* Success Icon */}
            <div style={{ 
              width: 60, 
              height: 60, 
              borderRadius: '50%', 
              background: '#4CAF50', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20,6 9,17 4,12"></polyline>
              </svg>
            </div>

            <h3 style={{ 
              marginBottom: 12, 
              fontSize: 20, 
              fontWeight: 600, 
              color: '#4CAF50',
              fontFamily: 'NeueEinstellung'
            }}>
              Đăng ký thành công!
            </h3>
            
            <p style={{ 
              marginBottom: 24, 
              fontSize: 14, 
              color: '#666',
              lineHeight: 1.5
            }}>
              Tài khoản của bạn đã được tạo thành công. Vui lòng đăng nhập để tiếp tục.
            </p>
            
            <button
              onClick={handleSuccessConfirm}
              style={{
                width: '100%',
                height: 44,
                background: '#4CAF50',
                color: '#fff',
                border: 'none',
                borderRadius: 22,
                fontSize: 16,
                fontWeight: 500,
                cursor: 'pointer',
                fontFamily: 'NeueEinstellung'
              }}
            >
              Đăng nhập ngay
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const inputStyle = {
  width: '100%',
  height: 44,
  border: '1px solid #bfc3b7',
  borderRadius: 22,
  padding: '0 44px 0 16px',
  fontSize: 16,
  marginTop: 4,
  outline: 'none',
  boxSizing: 'border-box',
};

const btnStyle = {
  width: 150,
  height: 48,
  background: '#5b6754',
  color: '#fff',
  border: 'none',
  borderRadius: 24,
  fontSize: 16,
  margin: '12px 0',
  cursor: 'pointer',
  fontFamily: 'NeueEinstellung',
  fontWeight: 300,
  float: 'right',
};

const eyeIconStyle = {
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: 20,
  cursor: 'pointer',
  userSelect: 'none',
};

export default RegisterPage;
